import COS from './cos-js-sdk-v5.min.js';
import { newApiURL } from '../../config/index.js';
import { Loading } from 'element-ui';
import { proURL, proURL2 } from '../../config/index.js';

const hostname = location.hostname;
// COS 配置信息
const COS_CONFIG = {
  SecretId: 'AKIDZK2ZzCE9qKaZLwJSM1YqvnR3YpuyumTy',
  SecretKey: 'ra6UggV8YoqfGd0GJMFxeO1S4XmnY6Sc',
  Bucket: hostname == proURL || hostname == proURL2 ? 'project-1315090369' : 'project-dev-1315090369',
  Region: 'ap-chengdu',
};

// 路径前缀
const prefix = `https://${COS_CONFIG.Bucket}.cos.${COS_CONFIG.Region}.myqcloud.com/`;
/**
 * 下载文件（支持单个和多个文件）
 * @param {string|Array<string>} paths 文件路径（单个或多个）
 * @param {string} [filename] 下载后的文件名，可选传
 */
export function downloadFiles(paths, filename) {
  return new Promise((resolve, reject) => {
    const loadingInstance = Loading.service({
      lock: true,
      text: '正在下载中，请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)',
    });

    if (!paths) {
      loadingInstance.close();
      reject(new Error('No paths provided'));
      return;
    }
    if (typeof paths === 'string') {
      paths = paths.split(',').map((path) => path.trim());
    }
    if (Array.isArray(paths) && paths.length > 1) {
      // 如果是数组且有多个路径，调用 downloadMultipleFiles
      downloadMultipleFiles(paths)
        .then(resolve)
        .catch((err) => {
          loadingInstance.close();
          reject(err);
        })
        .finally(() => {
          loadingInstance.close();
        });
    } else {
      // 否则，调用 downloadFile
      const singlePath = Array.isArray(paths) ? paths[0] : paths;
      downloadSingleFile(singlePath, filename)
        .then(resolve)
        .catch((err) => {
          loadingInstance.close();
          reject(err);
        })
        .finally(() => {
          loadingInstance.close();
        });
    }
  });
}
/**
 * 下载单个文件
 * @param {string} url 文件路径 （全路径）
 * @param {string} [filename] 下载后的文件名，可选传
 * @returns {Promise} 返回下载结果
 */
function downloadSingleFile(url, filename) {
  return new Promise((resolve) => {
    const timestamp = new Date().getTime();
    const a = document.createElement('a');
    a.href = `${url}?t=${timestamp}`;
    if (a.href.includes('https://cdn.kejiankeji.com/')) {
      a.target = '_blank';
    }
    a.download = filename; // 设置下载文件的名称
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    resolve();
  });
}
/**
 * 下载腾讯云 COS 对象
 * @param {string} key 对象键（对象在存储桶中的唯一标识）
 * @param {string} [filename] 下载后的文件名，可选
 * @returns {Promise} 返回下载结果
 */
function downloadCosObject(key, filename) {
  // 去掉前缀，保留对象的键
  const objectKey = key.replace(prefix, '');
  return new Promise((resolve, reject) => {
    const cos = new COS({
      SecretId: COS_CONFIG.SecretId,
      SecretKey: COS_CONFIG.SecretKey,
    });

    cos.getObject(
      {
        Bucket: COS_CONFIG.Bucket,
        Region: COS_CONFIG.Region,
        Key: objectKey, // 使用修正后的 key
        DataType: 'blob',
      },
      function (err, data) {
        if (err) {
          reject(err);
          return;
        }

        // 创建 Blob URL
        const blob = new Blob([data.Body]);
        const downloadUrl = window.URL.createObjectURL(blob);

        downloadSingleFile(downloadUrl, filename || objectKey);
        resolve(data);
      }
    );
  });
}
/**
 * 多文件压缩下载
 * @param {Array<string>} keys 对象键数组（多个文件的 COS 路径）
 * @returns {Promise} 返回压缩下载结果
 */
function downloadMultipleFiles(keys) {
  return new Promise((resolve, reject) => {
    const timestamp = new Date().getTime();
    const zipFileName = `file${timestamp}.zip`;
    const zipPath = `/temporary/${zipFileName}`;

    const cos = new COS({
      SecretId: COS_CONFIG.SecretId,
      SecretKey: COS_CONFIG.SecretKey,
    });
    // 构建压缩任务请求
    const host = `${COS_CONFIG.Bucket}.ci.${COS_CONFIG.Region}.myqcloud.com/file_jobs`;
    const url = `https://${host}`;

    const keyConfig = keys.map((item) => {
      let match = item.match(/\.com\/(.*)$/);
      if (match) {
        return { Key: match[1] };
      }
    });

    console.log('keyConfig', keyConfig);
    // 构建压缩任务配置
    const body = COS.util.json2xml({
      Request: {
        Tag: 'FileCompress',
        Operation: {
          FileCompressConfig: {
            Flatten: '1',
            Format: 'zip',
            KeyConfig: keyConfig,
          },
          Output: {
            Bucket: COS_CONFIG.Bucket,
            Region: COS_CONFIG.Region,
            Object: zipPath,
          },
          UserData: '',
        },
      },
    });
    // 提交压缩任务
    cos.request(
      {
        Method: 'POST',
        Key: 'file_jobs',
        Url: url,
        Body: body,
        ContentType: 'application/xml',
      },
      function (err, data) {
        if (err) {
          reject(err);
          return;
        }
        // 获取任务 ID
        const jobId = data.Response.JobsDetail.JobId;
        // 查询压缩任务状态
        checkCompressionStatus(jobId, zipFileName, resolve, reject);
      }
    );
  });
}
/**
 * 查询压缩任务状态,一旦成功就开始下载
 * @param {Array<string>} keys 对象键数组（多个文件的 COS 路径）
 * @returns {Promise} 返回压缩下载结果
 */
function checkCompressionStatus(jobId, zipFileName, resolve, reject) {
  // 创建 COS 实例
  const cos = new COS({
    SecretId: COS_CONFIG.SecretId,
    SecretKey: COS_CONFIG.SecretKey,
  });
  // 使用 cos.request 查询压缩任务状态
  const checkStatus = () => {
    cos.request(
      {
        Method: 'GET',
        Key: `file_jobs/${jobId}`,
        Url: `https://${COS_CONFIG.Bucket}.ci.${COS_CONFIG.Region}.myqcloud.com/file_jobs/${jobId}`,
        ContentType: 'application/xml',
      },
      function (err, data) {
        if (err) {
          reject(err);
          return;
        }
        // 获取任务状态
        const status = data.Response.JobsDetail.State;
        console.log('data.Response.JobsDetail', data.Response);
        if (status === 'Success') {
          const downloadUrl = `https://${COS_CONFIG.Bucket}.cos.${COS_CONFIG.Region}.myqcloud.com/temporary/${zipFileName}`;
          downloadSingleFile(downloadUrl, zipFileName);
          resolve(data);
        } else if (status === 'Failed') {
          reject(new Error('压缩任务失败'));
          // setTimeout(checkStatus, 2000);
        } else {
          // 继续查询状态，每2秒查询一次
          setTimeout(checkStatus, 2000);
        }
      }
    );
  };
  // 开始查询状态
  checkStatus();
}

/**
 * 删除文件
 * @param {Object} vue Vue实例
 * @param {string} url 文件路径
 * @returns {Promise} 返回压缩下载结果
 * @param {boolean} isAdmin 是否为平台删除，默认否
 */
export function deleteFile(vue, paths, isAdmin = false) {
  if (!paths) return false;

  let src = [];
  if (Array.isArray(paths)) {
    // 如果 paths 是数组，直接处理
    src = paths.map((path) => path.trim());
  } else if (typeof paths === 'string') {
    // 如果 paths 是字符串，分割成数组
    src = paths.split(',').map((path) => path.trim());
  }

  if (src.length) {
    src = src.map((singlePath) => singlePath.replace(prefix, ''));
    deleteSingleFile(vue, src, isAdmin);
  }
}
/**
 * 删除单个文件
 * @param {Object} vue Vue实例
 * @param {Array} urls 路径数组
 * @returns {Promise} 返回结果
 */
export function deleteSingleFile(vue, urls, isAdmin = false) {
  if (!urls.length) return;

  return new Promise((resolve) => {
    const path = isAdmin ? '/admin/file/del' : '/collective/file/del';
    vue.$request.post(path, { urls: urls }).then((res) => {
      resolve(res);
    });
  });
}
/**
 * 下载单个文件
 * @param {string} url 文件路径（非全路径）
 * @param {string} [filename] 下载后的文件名，可选传
 * @returns {Promise} 返回下载结果
 */
export function downloadKeyFile(url, filename) {
  const timestamp = new Date().getTime();
  const a = document.createElement('a');
  a.href = `${newApiURL}${url}?t=${timestamp}`;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * 判断文件类型
 * @param {string} url 文件路径
 * @returns {Promise} 返回判断结果
 */
export function findType(url) {
  const lowerUrl = url.toLowerCase(); // 将 URL 转换为小写
  if (lowerUrl.endsWith('.png') || lowerUrl.endsWith('.jpg') || lowerUrl.endsWith('.jpeg') || lowerUrl.endsWith('.gif')) {
    return 'image';
  } else if (lowerUrl.endsWith('.mp4')) {
    return 'video';
  } else if (lowerUrl.endsWith('.pdf')) {
    return 'pdf';
  } else if (lowerUrl.endsWith('.docx')) {
    return 'docx';
  } else if (lowerUrl.endsWith('.doc')) {
    return 'doc';
  } else if (lowerUrl.endsWith('.xls')) {
    return 'xls';
  } else if (lowerUrl.endsWith('.xlsx')) {
    return 'xlsx';
  } else if (lowerUrl.endsWith('.txt')) {
    return 'txt';
  } else if (lowerUrl.endsWith('.zip')) {
    return 'zip';
  } else if (lowerUrl.endsWith('.rar')) {
    return 'rar';
  } else if (lowerUrl.endsWith('.dwg')) {
    return 'dwg';
  } else {
    return '';
  }
}
